module.exports = __webpack_public_path__ + "static/media/ALUMINIO.5125f6cc.mp4";